<script setup lang="ts">
import { ref, watchEffect, onMounted, onBeforeUnmount } from "vue";

interface Props {
  isOpen?: boolean;
  disabled?: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits(["change"]);

const isOpen = ref<boolean>(props.isOpen || false);
const bodyEl = ref<any>(null);
const bodyStyle = ref({});
const toggle = () => (isOpen.value = !isOpen.value);
const update = () => {
  if (!props.disabled) {
    bodyStyle.value = {
      maxHeight: `${isOpen.value ? bodyEl.value?.scrollHeight : 0}px`,
    };
    emit("change", isOpen.value);
  }
  return;
};
watchEffect(update);
onMounted(() => window.addEventListener("resize", update));
onBeforeUnmount(() => window.removeEventListener("resize", update));
</script>

<template>
  <div>
    <div
      :class="$style.toggle"
      @click="toggle"
    >
      <slot
        name="toggle"
        :open="isOpen"
      />
    </div>
    <div
      ref="bodyEl"
      :class="$style.body"
      :style="bodyStyle"
    >
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" module>
.body {
  @apply max-h-0 overflow-hidden;
  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.toggle,
.toggle * {
  @apply cursor-pointer;
}
</style>
